import countriesJSON from "../../../../src/data/countries.json";
import logger from "./logger";
import { Loader } from "./loader";

export class SignupHelper {

	static theForm;
	static emojiRegex = /\p{Extended_Pictographic}/gu;
	static onlyLettersRegex = /[^A-Za-z]/g;

	static controlDaysWithYear = () => {
		const yearSelect = document.getElementById('BirthYearSelect');
		const monthSelect = document.getElementById('BirthMonthSelect');
		const daySelect = document.getElementById('BirthDaySelect');

		yearSelect.addEventListener('change', (e) => {
			const selectedYear = e.target.value;

			if (monthSelect.value === "2") {
				if (this.isLeapYear(selectedYear)) {
					const newOption = document.createElement('option');
					newOption.value = "29";
					newOption.textContent = "29";

					daySelect.appendChild(newOption);
				} else {
					const option = document.querySelector('option[value="29"]');
					if (option) option.remove();
				}
			}
		});
	}

	static controlDaysWithMonths = () => {
		const yearSelect = document.getElementById('BirthYearSelect');
		const monthSelect = document.getElementById('BirthMonthSelect');
		const daySelect = document.getElementById('BirthDaySelect');

		monthSelect.addEventListener('change', (e) => {
			const monthsDays = {
				1: 31,
				2: this.isLeapYear(yearSelect.value) ? 29 : 28,
				3: 31,
				4: 30,
				5: 31,
				6: 30,
				7: 31,
				8: 31,
				9: 30,
				10: 31,
				11: 30,
				12: 31
			};
			daySelect.innerHTML = `<option value="" selected disabled>${LL('DAY')}</option>`;
			for (let i = 1; i <= monthsDays[e.target.value]; i++) {
				daySelect.innerHTML += `<option value="${i}">${i}</option>`;
			}
		})
	}

	static isLeapYear = (year) => {
		const date = new Date(year, 1, 29);
		return date.getMonth() === 1;
	}

	static controlEmail = async (emailField) => {
		let msgEmail = document.querySelector('.msg.msg-email');
		msgEmail && msgEmail.remove();
		const box = emailField.closest('.box');

		const debouncedHandler = this.getDebouncedEmailInput(box);
		emailField.addEventListener('input', debouncedHandler);
	}

	static getDebouncedEmailInput = (box) => {
		return this.debounce((e) => this.handleEmailInput(e, box), 500);
	}

	static handleEmailInput = (e, box) => {
		let str = e.target.value;
		//logger.log(str);
		this.checkEmail(str)
			.then((response) => {
				//logger.log(response);
				if (response.invalid) {
					box.classList.remove('good', 'bad_taken', 'bad');
					box.classList.add('bad');
				} else if (!response.available) {
					box.classList.remove('good', 'bad');
					box.classList.add('bad_taken');
				} else if (response.available) {
					box.classList.remove('bad_taken', 'bad');
					box.classList.add('good');
				}
			})
			.finally(() => {
				this.checkForBadInputs();
			})
	} 

	static checkEmail = async (email) => {
		const resJSON = await fetch(URL_API('isEmailAvailable', 'user'), {
			method: 'POST',
			headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
			body: `email=${email}`
		});
		return await resJSON.json();
	}

	static controlUsername = (usernameField) => {
		let msgUsername = document.querySelector('.msg.msg-login');
		if (msgUsername) msgUsername.remove();

		const box = usernameField.closest('.box');
		const debouncedHandler = this.getDebouncedUsernameInput(usernameField, box);

		usernameField.addEventListener('input', debouncedHandler);
	}

	static getDebouncedUsernameInput = (usernameField, box) => {
		return this.debounce((e) => this.handleUsernameInput(e, usernameField, box), 500);
	}

	static handleUsernameInput = (e, usernameField, box) => {
		let str = e.target.value;

		// Prevent emojis
		if (this.emojiRegex.test(usernameField.value)) {
			usernameField.value = usernameField.value.replace(this.emojiRegex, '');
		}

		// Check min and max length
		if (usernameField.value.length >= 6 && usernameField.value.length <= 16) {
			this.checkUsername(str).then((response) => {
				if (response.available) {
					box.classList.remove('bad_username');
					box.classList.add('good');
					box.classList.remove('bad');
				} else {
					box.classList.remove('good');
					box.classList.add('bad_username');
				}
			})
			.finally(() => {
				this.checkForBadInputs();
			})
		} else {
			box.classList.add('bad');
			box.classList.remove('good');
			box.classList.remove('bad_username');
		}
	}

	static debounce = (callback, delay) => {
		let timeoutId;
		return (...args) => {
			clearTimeout(timeoutId);
			timeoutId = setTimeout(() => {
				callback(...args);
			}, delay);
		};
	}

	static checkUsername = async (username) => {
		const resJSON = await fetch(URL_API('isUsernameAvailable', 'user'), {
			method: 'POST',
			headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
			body: `username=${username}`
		});
		return await resJSON.json();
	}

	static controlPassword = (passwordField) => {
		const box = passwordField.closest('.box');

		passwordField.addEventListener('input', () => {
			box.classList.remove('bad');
			box.classList.remove('bad_password');
			box.classList.remove('good');

			if (passwordField.value.length > 0) {
				if (passwordField.value.length >= 6 && passwordField.value.length <= 16) {
					box.classList.add('good');
				} else {
					box.classList.add('bad_password');
					box.classList.remove('bad');
				}
			}

			this.checkForBadInputs();
		});
	}

	static controlFirstName = (fnameField) => {
		const box = fnameField.closest('.box');

		fnameField.addEventListener('input', () => {
			box.classList.remove('bad_fname');
			box.classList.remove('good');
			box.classList.remove('bad');

			//prevent emojis
			if (this.emojiRegex.test(fnameField.value)) {
				fnameField.value = fnameField.value.replace(this.emojiRegex, '');
			}

			//prevent non letters
			if(this.onlyLettersRegex.test(fnameField.value)) {
				fnameField.value = fnameField.value.replace(this.onlyLettersRegex, '');
			}

			if (fnameField.value.length > 0) {
				box.classList.add('good');
				box.classList.remove('bad');
			} else {
				box.classList.add('bad_fname');
				box.classList.add('bad');
			}

			this.checkForBadInputs();
		});
	}

	static controlLastName = (lnameField) => {
		const box = lnameField.closest('.box');

		lnameField.addEventListener('input', () => {
			box.classList.remove('bad_fname');
			box.classList.remove('good');
			box.classList.remove('bad');

			//prevent emojis
			if (this.emojiRegex.test(lnameField.value)) {
				lnameField.value = lnameField.value.replace(this.emojiRegex, '');
			}

			//prevent non letters
			if(this.onlyLettersRegex.test(lnameField.value)) {
				lnameField.value = lnameField.value.replace(this.onlyLettersRegex, '');
			}

			if (lnameField.value.length > 0) {
				box.classList.add('good');
				box.classList.remove('bad');
			} else {
				box.classList.add('bad_fname');
				box.classList.add('bad');
			}

			this.checkForBadInputs();
		});
	}

	static controlBirthday = (birthdayInputs) => {
		birthdayInputs.forEach((input) => {
			input.addEventListener('change', () => {
				birthdayInputs.forEach(element => {
					const box = element.closest('.box');

					setTimeout(() => {
						if (element.value) {
							box.classList.add('good');
							box.classList.remove('bad');
						} else {
							box.classList.remove('good');
						}

						this.checkForBadInputs();
					}, 0)

				})
			});
		});
	}

	static controlPassVisibility = (passVisibilityIcons) => {
		if (passVisibilityIcons) {
			passVisibilityIcons.forEach((icon) => {
				icon.addEventListener('click', (e) => {
					let passField = e.target.parentNode.querySelector('input[name=password]');
					passField.type === 'password' ? passField.type = 'text' : passField.type = 'password';
					icon.classList.toggle('visible');
					return true;
				})
			})
		}
	}

	static controlCurrency = (currencySelect) => {
		const currencyBox = currencySelect.closest('.box');
		const currencyLabel = currencyBox.querySelector('.selectCurrency');

		const currencyOptions = currencySelect.querySelectorAll('option');
		if (currencyOptions.length === 2) {
			currencySelect.value = currencyOptions[1].value;
			currencySelect.disabled = true;
			currencyBox.classList.add('good');
			currencyLabel.classList.add('focus');
		} else {
			currencySelect.disabled = false;
		}

		currencySelect.addEventListener('change', () => {
			setTimeout(() => {
				if (currencySelect.value) {
					currencyBox.classList.add('good');
					currencyBox.classList.remove('bad');
					currencyLabel.classList.add('focus');
				} else {
					currencyBox.classList.remove('good');
					currencyLabel.classList.remove('focus');
				}

				this.checkForBadInputs();
			}, 0);
		});

		currencySelect.addEventListener('focus', (e) => {
			let box = e.target.closest('.box');
			if (box) {
				box.classList.add('focus');
				currencyLabel.classList.add('focus');
			}
		});

		currencySelect.addEventListener('blur', (e) => {
			let box = e.target.closest('.box');
			if (box && !currencySelect.value) {
				box.classList.remove('focus');
				currencyLabel.classList.remove('focus');
			}
		});
	}

	static controlFocus = (inputFields) => {
		inputFields.forEach((field) => {
			field.addEventListener('focus', (e) => {
				let box = e.target.closest('.box');
				if (box) {
					box.classList.add('focus');
					return false;
				}
			});

			field.addEventListener('focusout', (e) => {
				if (e.target.value === "") e.target.closest('.box').classList.remove('focus')
			});
		})
	}

	static toggleForm = (removeMsgs = true) => {
		let messages = this.theForm.querySelectorAll('.msg');
		if (messages && removeMsgs) {
			messages.forEach((msg) => msg.remove());
		}

		if(!this.checkAllRequiredFieldsOnSubmit()) return false;
		if(!this.checkForBadInputs(removeMsgs)) return false;
		return true;
	}

	static checkForBadInputs = (removeMsgs = true) => {
		const badInputs = this.theForm.querySelectorAll('.box.bad, .box.bad_taken, .box.bad_username, .box.bad_password');

		const errorElement = this.theForm.querySelector('.msg');
		if(removeMsgs) {
			if(!badInputs.length) {
				errorElement?.remove();
			} else if (!errorElement) {
				document.querySelector('form button').insertAdjacentHTML('beforebegin', `<div class="msg bad">Please check your inputs and try again.<br/> Some fields do not comply with the account creation requirements.</div>`);
			}
		}

		if(badInputs.length) {
			return false;
		} else {
			return true;
		}
	}

	static checkAllRequiredFieldsOnSubmit = () => {
    const requiredFields = this.theForm.querySelectorAll('[required]');
    let emptyFields = [];

    requiredFields.forEach(field => {
      if (!field.value.trim()) {
				if(field.closest('.box')) field.closest('.box').classList.add('bad');
        emptyFields.push(field.name || field.id || 'field');
      }
    });

    if (emptyFields.length > 0) {
			document.querySelector('form button').insertAdjacentHTML('beforebegin', `<div class="msg bad">Please check your inputs and try again.<br/> Some fields do not comply with the account creation requirements.</div>`);
			return false;
		}

		return true;
	}

	static controlGender = (genderSelect) => {
		const genderBox = genderSelect.closest('.box');
		const genderLabel = genderBox.querySelector('.selectGender');

		genderSelect.addEventListener('focus', (e) => {
			let box = e.target.closest('.box');
			if (box) {
				box.classList.add('focus');
				genderLabel.classList.add('focus');
			}
		});

		genderSelect.addEventListener('blur', (e) => {
			let box = e.target.closest('.box');
			if (box && !genderSelect.value) {
				box.classList.remove('focus');
				genderLabel.classList.remove('focus');
			}
		});

		genderSelect.addEventListener('change', (e) => {
			let box = e.target.closest('.box');
			if(genderSelect.value) {
				box.classList.add('good');
				box.classList.remove('bad');
				genderLabel.classList.add('good');
				this.checkForBadInputs(true);
			}		
		})
	}

	static changeState = (countrySelect, selectStates) => {
		const selectedCountry = countrySelect.value;
		const states = countriesJSON[selectedCountry].provinces;
		const countriesUseISO = ['AU', 'CA', 'US'];

		let options = '<option selected value="" required disabled>State/Province</option>';
		Object.entries(states).forEach(([iso, state]) => {
			if (countriesUseISO.includes(selectedCountry)) {
				options += `<option value="${iso}">${state}</option>`;
			} else {
				options += `<option value="${state}">${state}</option>`;
			}
		})

		selectStates.innerHTML = options;

	}

	static changeFlag = (flagInput, countrySelect) => {
		logger.log(countrySelect.options);
		let code = countrySelect.options[countrySelect.selectedIndex].dataset.phonecode;
		let flagName = countrySelect.options[countrySelect.selectedIndex].text.toLowerCase().replaceAll(' ', '-').replaceAll("'", "");

		flagInput.value = '+ ' + code;
		flagInput.style.backgroundImage = "url('/public/img/icons/flags/" + flagName + ".svg')";
		logger.log(flagName);
	}

	static trimOptionLabels = () => {
		const monthSelect = document.getElementById('BirthMonthSelect');
		const daySelect = document.getElementById('BirthDaySelect');
		const yearSelect = document.getElementById('BirthYearSelect');

		const isMobile = window.matchMedia("(max-width: 500px)").matches;

		const fullLabels = {
			1: "January",
			2: "February",
			3: "March",
			4: "April",
			5: "May",
			6: "June",
			7: "July",
			8: "August",
			9: "September",
			10: "October",
			11: "November",
			12: "December"
		};
		const shortLabels = {
			1: "Jan",
			2: "Feb",
			3: "Mar",
			4: "Apr",
			5: "May",
			6: "Jun",
			7: "Jul",
			8: "Aug",
			9: "Sep",
			10: "Oct",
			11: "Nov",
			12: "Dec"
		};

		for (let option of monthSelect.options) {
			if (option.value) {
				const value = option.value;
				option.textContent = isMobile ? shortLabels[value] : fullLabels[value];
			} else {
				option.textContent = isMobile ? "M" : "Month";
			}
		}

		const dayEmptyValueOption = daySelect.querySelector('option[value=""]');
		const yearEmptyValueOption = yearSelect.querySelector('option[value=""]');

		dayEmptyValueOption.textContent = isMobile ? "D" : "Day";
		yearEmptyValueOption.textContent = isMobile ? "Y" : "Year";
	}

	static showLoader = () => {
		const reg = document.querySelector('.reg');
		const regBox = document.querySelector('.reg-box');
		logger.log(reg, regBox)
		if (!reg || !regBox) return;
		regBox.style.display = 'none';

		Loader.show('.reg')
			.then(() => {
				const textElement = document.createElement('div');
				textElement.classList.add('text-box');

				textElement.innerHTML = `
					<p>Creating your account…</p>
					<p>Please wait a moment while we set things up for you.</p>
				`;

				reg.appendChild(textElement);
			});
	}

	static hideLoader = () => {
		const reg = document.querySelector('.reg');
		const regBox = document.querySelector('.reg-box');
		if (!reg || !regBox) return;
		regBox.style.display = 'flex';
		if (reg.querySelector('.text-box')) reg.querySelector('.text-box').remove();
		Loader.hide('.reg');
	}

	static validateStep1 = () => {

		let showingMsgs = document.querySelectorAll('.msg');
		(showingMsgs && showingMsgs.length > 0) && showingMsgs.forEach((msg) => msg.remove());

		const emailInput = this.theForm.querySelector('input[name="email"]');
		let emailValue = emailInput.value.replaceAll(' ', '');
		const loginInput = this.theForm.querySelector('input[name="login"]');
		let loginValue = loginInput.value.replaceAll(' ', '');
		const passwordInput = this.theForm.querySelector('input[name="password"]');
		let passwordValue = passwordInput.value.replaceAll(' ', '');
		const firstNameInput = this.theForm.querySelector('input[name="first_name"]');
		let firstNameValue = firstNameInput.value.replaceAll(' ', '');
		const lastNameInput = this.theForm.querySelector('input[name="last_name"]');
		let lastNameValue = lastNameInput.value.replaceAll(' ', '');

		if (emailInput.closest('.box').classList.contains('bad') || emailInput.closest('.box').classList.contains('bad_taken') || emailValue === '') {
			// emailInput.closest('.field').insertAdjacentHTML('afterend', `<div class="msg bad msg-email">${LL('invalid_email')}.</div>`);
			this.theForm.querySelector('.fields.gender').insertAdjacentHTML('afterend', `<div class="msg bad msg-gender">Please check your inputs and try again.<br/> Some fields do not comply with the account creation requirements.</div>`);
			return false;
		}

		if (loginInput.closest('.box').classList.contains('bad') || loginValue === '') {
			// loginInput.closest('.field').insertAdjacentHTML('afterend', `<div class="msg bad msg-username">${LL('invalid_username')}.</div>`);
			this.theForm.querySelector('.fields.gender').insertAdjacentHTML('afterend', `<div class="msg bad msg-gender">Please check your inputs and try again.<br/> Some fields do not comply with the account creation requirements.</div>`);
			return false;
		}
		if (passwordValue === '' || passwordValue.length < parseInt(passwordInput.minLength)) {
			const box = passwordInput.closest('.box');
			box.classList.add('bad');
			// passwordInput.closest('.field').insertAdjacentHTML('afterend', `<div class="msg bad msg-password">${LL('invalid_password')}.</div>`);
			this.theForm.querySelector('.fields.gender').insertAdjacentHTML('afterend', `<div class="msg bad msg-gender">Please check your inputs and try again.<br/> Some fields do not comply with the account creation requirements.</div>`);
			return false;
		}

		if (firstNameValue === '' || lastNameValue === '') {
			// firstNameInput.closest('.fields').insertAdjacentHTML('afterend', `<div class="msg bad msg-first_name">${LL('fullname_required')}.</div>`);
			this.theForm.querySelector('.fields.gender').insertAdjacentHTML('afterend', `<div class="msg bad msg-gender">Please check your inputs and try again.<br/> Some fields do not comply with the account creation requirements.</div>`);
			return false;
		}

		if (!this.genderChecked(this.theForm)) {
			const box = this.theForm.querySelector('.fields.gender').querySelector('.box');
			box.classList.add('bad');
			this.theForm.querySelector('.fields.gender').insertAdjacentHTML('afterend', `<div class="msg bad msg-gender">Please check your inputs and try again.<br/> Some fields do not comply with the account creation requirements.</div>`);
			// this.theForm.querySelector('.fields.gender').insertAdjacentHTML('afterend', `<div class="msg bad msg-gender">${LL('check_boxes')}.</div>`);
			return false;
		}
		return true;
	}

	static controlMultipleInputs = (multipleFields) => {
		multipleFields.forEach(selector => {
			const field = this.theForm.querySelector(`.box ${selector}`);
			field.addEventListener('input', () => {
        this.validateSingleInput(field);
      });
		});
	} 
	static validateStep2 = (multipleFields) => {
		let showingMsgs = document.querySelectorAll('.msg');
		(showingMsgs && showingMsgs.length > 0) && showingMsgs.forEach((msg) => msg.remove());

		let result = true;

		multipleFields.forEach(selector => {
			const field = this.theForm.querySelector(`.box ${selector}`);
			if (!this.validateSingleInput(field)) result = false;
		});

		if(!this.checkForBadInputs()) result = false;

		return result;
	}


	static genderChecked = (theForm) => {
		const genderSelect = theForm.querySelector('#gender_id');
		return genderSelect.value !== "";
	}

	static validateSingleInput = (input) => {
		const str = input.value;
		const box = input.closest('.box');

		if (str.length > 0) {
			box.classList.add('good');
			box.classList.remove('bad');
			this.checkForBadInputs();
			return true;
		} else {
			box.classList.add('bad');
			box.classList.remove('good');
			this.checkForBadInputs();
			return false;
		}
	}

	static clearMessages = () => {
		let messages = this.theForm.querySelectorAll('.msg');
		if (messages) messages.forEach((m) => m.remove()); // hides all
	}

	static sanitizeInputs() {
		const inputs = document.querySelectorAll('#cell_phone, #zip');
		inputs.forEach(input => {
			input.addEventListener('keyup', this.sanitizeInput);
		});
	}

	static sanitizeInput = (e) => {
		e.target.value = e.target.value.replace(/\D/g, '');
	}

	static doFetch(fn, data, website, shortcut) {
		this.showLoader();

		const options = {
			method: 'post',
			headers: {'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'},
			body: new URLSearchParams(data).toString()
		}

		fetch(URL_API(fn, 'user'), options)
			.then(response => response.json())
			.then(data => {
				logger.log(data.response);
				const type = (data.response.code >= 200 && data.response.code <= 202) ? 'good' : 'bad';

				if (type === 'good') { // account created
					// clear messages if showing
					this.clearMessages();
					this.accountCreated();
					setTimeout(() => {
						this.googleTag(data.response.hash ?? '', website, shortcut);
						window.location.href = SignupHelper.getRedirectUrl(data);
					}, 2000)
				} else { // couldn't create account
					this.hideLoader();
					this.accountNotCreated(type, data);
				}
				// enable form inputs
				this.toggleForm(false);
			})
			.catch(error => {
				SignupHelper.hideLoader();
				SignupHelper.accountNotCreated('bad', {});
				logger.error("Fetch failed:", error);
			});

	}

	static googleTag(hash, domain, shortcut) {
		window.dataLayer = window.dataLayer || [];
		dataLayer.push({
			'event': 'ga_signup',
			'ga_user_hash': hash,
			'ga_referrer': document.querySelector('input[name="t_ref"]').value.replace(domain, shortcut),
			'ga_first_referrer': document.querySelector('input[name="t_fref"]').value.replace(domain, shortcut),
			'ga_current_url': document.querySelector('input[name="t_cur"]').value.replace(domain, shortcut)
		});
	}

	static accountCreated() {
		document.querySelector('form button').insertAdjacentHTML('beforebegin', `<div class="msg good mt-15">${LL('account_created')}.</div>`);
	}

	static accountNotCreated(type, data) {
		const msg = data.response?.message ?? "Unknown error";
		document.querySelector('form button').insertAdjacentHTML(
			'beforebegin', 
			`<div class="msg general-error ${type}">
			<span>Something went wrong during sign-up.<br/> Please contact our <a href='/contact-us' target='_self'>Live Support</a>.</span>
			</div>`);
	}

	static getRedirectUrl(data) {
		const s_urlParams = new URLSearchParams(window.location.search);
		if (s_urlParams.has('bonus_code') && s_urlParams.get('bonus_code')) {
			return URL_PREFIX + `cashier?redeem&coupon=${s_urlParams.get('bonus_code').toUpperCase().replaceAll(' ', '')}`;
		} else if (s_urlParams.has('deposit') && s_urlParams.has('currency')) {
			return URL_PREFIX + `?deposit=${s_urlParams.get('deposit')}&currency=${s_urlParams.get('currency')}`;
		} else if (s_urlParams.has('fun-mode')) {
			return URL_PREFIX + 'acquisition-app/fun-mode';
		} else if (data.response.hasOwnProperty('redirect')) {
			return URL_PREFIX + data.response.redirect;
		} else {
			return URL_PREFIX;
		}
	}
}